<template>
  <IllustratedSection empty illustration="rich-inbox-empty" outlined>
    <template #headline>{{ $t('richinbox.empty.headline') }}</template>
    <template #subtitle>{{ $t('richinbox.empty.description') }}</template>
  </IllustratedSection>
</template>
